import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-md px-3 py-2 font-label text-sm transition-colors ${
      isActive
        ? "bg-accent-100 text-accent-900"
        : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
    }`;

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b backdrop-blur-md transition-colors ${
        scrolled
          ? "border-background-200 bg-background-50/95"
          : "border-background-200/60 bg-background-50/80"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4 md:h-[72px]">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label={`${site.name} 首页`}>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-chat-smile-2-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg text-foreground-950">{site.name}</span>
              <span className="mt-0.5 font-label text-[10px] uppercase tracking-[0.2em] text-foreground-400">
                {site.brandEn}
              </span>
            </span>
          </Link>

          <nav className="hidden flex-1 items-center justify-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === "/"} className={navClass}>
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden shrink-0 items-center gap-2 md:flex">
            <Link
              to="/guide"
              className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              选群指南
            </Link>
            <Link
              to="/ranking"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              查看群组排行
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
            aria-label={open ? "关闭导航菜单" : "打开导航菜单"}
            aria-expanded={open}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col gap-1 px-4 pb-4 pt-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={navClass}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/ranking"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-4 py-2.5 text-center font-label text-sm text-background-50"
            >
              查看群组排行
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}